import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
} from "@mui/material";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";

const DelegationActionPopup = ({
  open,
  onClose,
  onConfirm,
  actionType,
  loading = false,
  approveTitle = "Approve Delegation Request",
  declineTitle = "Decline Delegation Request",
  approvePrompt = "Are you sure you want to approve this delegation request?",
  declinePrompt = "Please provide a response message for declining this delegation request.",
  declinePlaceholder = "Please provide a reason for declining this delegation request...",
  declineHelperText = "Please provide a response message",
  approveButtonLabel = "Yes, Approve",
  declineButtonLabel = "Submit",
  cancelButtonLabel = "Cancel",
}) => {
  const [responseMessage, setResponseMessage] = useState("");
  const [messageError, setMessageError] = useState(false);

  const isApprove = actionType === "approve";
  const isDecline = actionType === "decline" || actionType === "reject";

  const handleConfirm = () => {
    if (isDecline && !responseMessage.trim()) {
      setMessageError(true);
      return;
    }

    onConfirm(isDecline ? responseMessage : null);
    setResponseMessage("");
  };

  const handleClose = () => {
    setResponseMessage("");
    setMessageError(false);
    onClose();
  };

  const handleMessageChange = (e) => {
    setResponseMessage(e.target.value);
    if (messageError) setMessageError(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          {isApprove ? approveTitle : declineTitle}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {isApprove && (
          <Typography variant="body1" sx={{ mb: 2 }}>
            {approvePrompt}
          </Typography>
        )}

        {isDecline && (
          <Box>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
              {declinePrompt} <span style={{ color: "#d32f2f" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={responseMessage}
              onChange={handleMessageChange}
              placeholder={declinePlaceholder}
              error={messageError}
              helperText={
                messageError ? declineHelperText : ""
              }
              disabled={loading}
              variant="outlined"
              size="small"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} variant="outlined">
          {isApprove ? cancelButtonLabel : "Close"}
        </Button>
        <Box sx={{ position: "relative" }}>
          <Button
            variant="contained"
            color={isApprove ? "success" : "error"}
            onClick={handleConfirm}
            disabled={loading || (isDecline && !responseMessage.trim())}
            sx={{ minWidth: 120 }}
          >
            {loading && (
              <LoadingComponent
                size={22}
                thickness={4}
                color="inherit"
                style={{ marginRight: 8 }}
              />
            )}
            {loading ? "" : isApprove ? approveButtonLabel : declineButtonLabel}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DelegationActionPopup;
